(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Search functionality for header search bar
  document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('Search-In-Header-Middle');
    const resetButton = document.querySelector('.header__search-reset');
    const searchForm = document.querySelector('.header__middle-center form');
    const predictiveSearch = document.getElementById('predictive-search-results-header');
    
    if (!searchInput) return;

    // Show/hide reset button based on input value
    searchInput.addEventListener('input', function() {
      if (this.value.trim() !== '') {
        resetButton.classList.add('visible');
      } else {
        resetButton.classList.remove('visible');
      }
      
      // Handle predictive search if enabled
      if (predictiveSearch && this.value.trim().length >= 2) {
        fetchPredictiveSearch(this.value.trim());
      } else if (predictiveSearch) {
        predictiveSearch.style.display = 'none';
      }
    });

    // Reset button functionality
    if (resetButton) {
      resetButton.addEventListener('click', function(e) {
        e.preventDefault();
        searchInput.value = '';
        searchInput.focus();
        resetButton.classList.remove('visible');
        if (predictiveSearch) {
          predictiveSearch.style.display = 'none';
        }
      });
    }

    // Close predictive search when clicking outside
    document.addEventListener('click', function(e) {
      if (predictiveSearch && !searchForm.contains(e.target)) {
        predictiveSearch.style.display = 'none';
      }
    });

    // Fetch predictive search results
    function fetchPredictiveSearch(searchTerm) {
      predictiveSearch.innerHTML = '<div class="predictive-search__loading-state"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
      predictiveSearch.style.display = 'block';
      
      fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article,page&resources[limit]=5&section_id=predictive-search`)
        .then(response => response.json())
        .then(data => {
          displayPredictiveResults(data);
        })
        .catch(error => {
          console.error('Predictive search error:', error);
          predictiveSearch.innerHTML = '<div class="predictive-search__result-item">Error loading results</div>';
        });
    }
    
    function displayPredictiveResults(data) {
      let html = '<ul class="predictive-search__results-list">';
      
      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        html += '<li class="predictive-search__result-item"><strong>Products</strong></li>';
        data.resources.results.products.forEach(product => {
          html += `
            <li class="predictive-search__result-item">
              <a href="${product.url}">
                ${product.image ? `<img src="${product.image}" alt="${product.title}" class="predictive-search__result-image">` : ''}
                <div class="predictive-search__result-content">
                  <div class="predictive-search__result-title">${product.title}</div>
                  <div class="predictive-search__result-price">${product.price}</div>
                </div>
              </a>
            </li>
          `;
        });
      }
      
      // if (data.resources && data.resources.results && data.resources.results.articles && data.resources.results.articles.length > 0) {
      //   html += '<li class="predictive-search__result-item"><strong>Articles</strong></li>';
      //   data.resources.results.articles.forEach(article => {
      //     html += `
      //       <li class="predictive-search__result-item">
      //         <a href="${article.url}">
      //           ${article.image ? `<img src="${article.image}" alt="${article.title}" class="predictive-search__result-image">` : ''}
      //           <div class="predictive-search__result-content">
      //             <div class="predictive-search__result-title">${article.title}</div>
      //           </div>
      //         </a>
      //       </li>
      //     `;
      //   });
      // }
      
      // if (data.resources && data.resources.results && data.resources.results.pages && data.resources.results.pages.length > 0) {
      //   html += '<li class="predictive-search__result-item"><strong>Pages</strong></li>';
      //   data.resources.results.pages.forEach(page => {
      //     html += `
      //       <li class="predictive-search__result-item">
      //         <a href="${page.url}">
      //           <div class="predictive-search__result-content">
      //             <div class="predictive-search__result-title">${page.title}</div>
      //           </div>
      //         </a>
      //       </li>
      //     `;
      //   });
      // }
      
      if ((!data.resources || !data.resources.results || 
          (data.resources.results.products && data.resources.results.products.length === 0) && 
          (data.resources.results.articles && data.resources.results.articles.length === 0) && 
          (data.resources.results.pages && data.resources.results.pages.length === 0))) {
        html += '<li class="predictive-search__result-item">No results found</li>';
      }
      
      html += '</ul>';
      predictiveSearch.innerHTML = html;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
